var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-page-creator-page"},[(_vm.showHeader)?_c('div',{staticClass:"admin-page-creator-page__title",style:(_vm.titleStyle)},[_c('span',{staticClass:"text-overflow"},[_vm._v(_vm._s(_vm.value.title))])]):_vm._e(),_c('div',{staticClass:"admin-page-creator-page__content",style:(_vm.style)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }